<div class="soft-card">
  <cdk-accordion>
    @if (data()?.itemVkforg; as vkforgs) {
    <cdk-accordion-item
      role="button"
      tabindex="0"
      #accordionItem="cdkAccordionItem"
      [expanded]="expanded()"
      [attr.aria-expanded]="accordionItem.expanded"
      class="flex flex-col"
    >
      <div
        class="font-semibold flex justify-between items-center cursor-pointer"
        (click)="accordionItem.toggle()"
      >
        <h6
          class="font-semibold text-light text-sm mb-1 uppercase leading-wide tracking-wide"
        >
          {{ '#ARTIKELINFO.PAGES.DETAIL.VKFORG.LISTUNG' | translate }}
        </h6>
        <div
          class="text-light bg-surface rounded-full p-3 cursor-pointer hover:bg-hover"
        >
          @if (!accordionItem.expanded) {
          <soft-icon name="fa-regular fa-chevron-down"></soft-icon>
          } @if (accordionItem.expanded) {
          <soft-icon name="fa-regular fa-chevron-up"></soft-icon>
          }
        </div>
      </div>
      <div
        [style.display]="accordionItem.expanded ? 'block' : 'none'"
        class="pt-2 bg-surface"
      >
        <div
          class="flex px-4 py-2 items-center justify-between w-full border-b border-b-solid border-b-separator border-t border-t-solid border-t-separator bg-surface-secondary"
        >
          <div class="text-[0.825rem] font-semibold">
            {{ '#ARTIKELINFO.PAGES.DETAIL.VKFORG.VKFORG' | translate }}
          </div>
          <div
            class="text-[0.825rem] font-semibold flex items-center justify-end text-right"
          >
            {{ '#ARTIKELINFO.PAGES.DETAIL.VKFORG.LISTUNG' | translate }}
          </div>
        </div>
        @for (vkforg of vkforgs; track vkforg) {
        <div
          class="flex px-4 py-3 items-center justify-between w-full border-b border-b-solid border-b-separator"
        >
          <div class="">{{ vkforg.vkforg?.vkforg }}</div>
          <div class="font-semibold flex items-center justify-end text-right">
            {{ vkforg.listing.kzgelistet }} - {{ vkforg.listing.title }}
          </div>
        </div>
        }
      </div>
    </cdk-accordion-item>
    }
  </cdk-accordion>
</div>
